import { Box } from '@mui/material';
import React from 'react';
import { theme } from 'ui-sdk/src/theme';
import { MarbleText } from '../texts/Text';

export const ActiveChatTitle: React.FC = ({ children }) => (
  <Box
    sx={{
      width: '100%',
      position: 'absolute',
      zIndex: 1,
      backgroundColor: 'white',
      border: 'none',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      fontWeight: 'bold',
      fontSize: '130%',
      boxShadow: { xs: '0 4px 2px -2px rgba(0, 0, 0, 0.15)', md: 'none' },
    }}
  >
    <MarbleText weight="med">{children}</MarbleText>
  </Box>
);
